import { Component, OnInit, OnDestroy, ViewChild, ElementRef, EventEmitter, ChangeDetectorRef, Output } from '@angular/core';
import { Logger } from '../../../../../core/logger/logger.service';
import { ApiHandlerService } from '../../../../../core/api-handlers';
import { SubSink } from 'subsink';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { HotelService } from '../../../hotel.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { tap } from 'rxjs/operators';
import { UtilityService } from '../../../../../core/services/utility.service';
import * as moment from 'moment';
import { browserRefresh } from '../../../../../../app/app.component';
import { DatePipe, PlatformLocation } from '@angular/common';
import { ThemeOptions } from 'projects/b2c/src/app/theme-options';

const log = new Logger('hotel/HotelSearchFormComponent');

export interface LocationI {
    cityId: string;
    cityName: string;
    countryCode: string;
    status: boolean;
    source: string;
}

@Component({
    selector: 'app-hotel-modify-search',
    templateUrl: './hotel-modify-search.component.html',
    styleUrls: ['./hotel-modify-search.component.scss']
})
export class HotelModifySearchComponent implements OnInit, OnDestroy {

    @ViewChild('destination_name', { static: false }) destination_name: ElementRef<HTMLElement>;
    @ViewChild('checkinDate', { static: false }) checkinDate: ElementRef<HTMLElement>;
    @ViewChild('checkoutDate', { static: false }) checkoutDate: ElementRef<HTMLElement>;
    private subSunk = new SubSink();
    regConfig: FormGroup;
    submitted: boolean = false;
    locations: LocationI[] = [];
    lastKeyupTstamp: number = 0;
    openRooms: boolean = false;
    noOfRooms: number = 0;
    minDate = new Date();
    isOpen = false as boolean;
    bsDateConf: Partial<BsDatepickerConfig> = {
        isAnimated: true,
        dateInputFormat: 'DD-MM-YYYY',
        rangeInputFormat: 'DD-MM-YYYY',
        showWeekNumbers: false,
        containerClass: 'theme-blue',
    };
    city: LocationI;
    booking_source: any;
    isLoading: boolean = false;
    guestCountData: {} = {};
    setMinDate: any;
    travellerCountError: any;
    roomError: any;
    submitSessionHotelSearchKeyCheck: any;
    travellersFadeinn: any;
    @Output() callResult = new EventEmitter<any>();
    public browserRefresh: boolean;
    noOfAdults: any = 0;
    noOfChild: any = 0;

    constructor(
        private apiHandlerService: ApiHandlerService,
        private fb: FormBuilder,
        private router: Router,
        private hotelService: HotelService,
        private ngxService: NgxUiLoaderService,
        public globals: ThemeOptions,
        private util: UtilityService,
        private cdr: ChangeDetectorRef,
        public location: PlatformLocation,
        public datepipe: DatePipe,
    ) {
        this.minDate = new Date();
        this.minDate.setDate(this.minDate.getDate());
    }

    ngOnInit(): void {
        this.createTravellerForm();
        this.createForm();
        this.onValueChange();
        let data1 = JSON.parse(sessionStorage.getItem('hotelSearchData'));
        this.browserRefresh = browserRefresh;
        this.regConfig.value['booking_source'] = data1['destination_id']['booking_source'];
        this.regConfig.patchValue({
            cityName: data1['cityName'],
            checkin: moment(data1['checkin']).format('DD-MM-YYYY'),
            checkout: moment(data1['checkout']).format('DD-MM-YYYY'),
            checkinDate: moment(data1['checkin']).format('DD-MM-YYYY'),
        });
        this.location.onPopState(() => {
            this.regConfig.value['booking_source'] = data1['destination_id']['booking_source'];
            this.regConfig.patchValue({
                cityName: data1['cityName'],
                checkin: moment(data1['checkin']).format('DD-MM-YYYY'),
                checkout: moment(data1['checkout']).format('DD-MM-YYYY'),
                checkinDate: moment(data1['checkin']).format('DD-MM-YYYY'),
            });
        });
        this.noOfRooms = data1['traveller'].length;
        data1['traveller'].forEach(element => {
            this.noOfAdults += element.adults;
            this.noOfChild += element.childrens;
        });
        this.regConfig.value['traveller'] = data1['traveller'];
    }

    createForm(): void {
        this.regConfig = this.fb.group({
            cityName: new FormControl('', [Validators.required]),
            checkin: new FormControl('', [Validators.required]),
            checkout: new FormControl('', [Validators.required]),
            checkinDate: new FormControl(''),
            traveller: this.fb.array([this.createTravellerForm()]),
        })
    }

    createTravellerForm() {
        return this.fb.group({
            adults: 1,
            childrens: 0
        });
    }

    travellers(controlName: string): FormArray {
        return this.regConfig.get(controlName) as FormArray;
    }

    addRoom() {
        if (this.regConfig.value['traveller'].length < 3) {
            this.noOfRooms++;
            this.noOfAdults++;
            this.travellers('traveller').push(this.createTravellerForm())
        }
    }

    removeRoom(i) {
        if (this.regConfig.value['traveller'].length > 0) {
            this.noOfRooms--;
            this.noOfAdults -= this.regConfig.value['traveller'][i]['adults'];
            this.noOfChild -= this.regConfig.value['traveller'][i]['childrens'];
            this.travellers('traveller').removeAt(i);
        }
    }

    onUpdateTraveller(i: any, travellerType: string, operation: string) {
        let traveller = this.travellers('traveller');
        let item = traveller.at(i);
        const adults = item.value['adults'];
        const childrens = item.value['childrens'];
        const control = traveller.controls[i]['controls'][travellerType];
        let result = 0;
        if (operation === 'minus') {
            result = control.value < 1 ? control.value : control.value - 1;
            if (travellerType == 'adults' && this.noOfAdults > 0) {
                this.noOfAdults -= 1;
            } else if (travellerType == 'childrens' && this.noOfChild >= 0) {
                this.noOfChild -= 1;
            }
        } else {
            result = control.value + 1;
        }
        let adultCount = 0, childCount = 0;
        if (travellerType == 'adults') {
            adultCount = adults;
            if (operation == 'plus' && adultCount <= 3) {
                this.noOfAdults += 1;
            }
        }
        if (travellerType == 'childrens') {
            childCount = childrens;
            if (operation == 'plus' && childCount <= 1) {
                this.noOfChild += 1;
            }
        }
        if (operation === 'minus' && travellerType == 'adults' && result < 1) {
            return false;
        }
        if (adultCount > 3 && operation === 'plus') {
            this.travellerCountError = true;
            this.roomError = false;
            return false;
        }
        if (childCount > 1 && operation === 'plus') {
            this.travellerCountError = true;
            this.roomError = false;
            return false;
        }
        this.travellerCountError = false;
        control.setValue(result);
        this.regConfig.patchValue({
            traveller: [control]
        });
    }

    hasError = (controlName: string, errorName: string) => {
        return ((this.submitted || this.regConfig.controls[controlName].touched) && this.regConfig.controls[controlName].hasError(errorName));
    }

    isOpenDropDown() {
        this.openRooms = !this.openRooms;
        return this.openRooms;
    }

    closeDropDown() {
        this.openRooms = false;
    }

    onSubmitTraveller() {
        this.travellersFadeinn = false;
    }

    closeTravellers() {
        this.travellersFadeinn = false;
    }

    noOfNights(i, o,) {
        return String((new Date(o).getTime() - new Date(i).getTime()) / (1000 * 60 * 60 * 24)) + ' Nights'
    }


    onValueChange() {
        this.subSunk.sink = this.regConfig.valueChanges.subscribe(val => {
            if (val.checkinDate[0] instanceof Date) {
                let checkin = formatDate(this.regConfig.value.checkinDate[0], 'DD-MM-YYYY'); // String((<Date>this.regConfig.value.checkinDate[0]).toLocaleDateString());
                let checkout = formatDate(this.regConfig.value.checkinDate[1], 'DD-MM-YYYY'); // String((<Date>this.regConfig.value.checkinDate[1]).toLocaleDateString());
                this.regConfig.patchValue({ checkin, checkout, nights: this.noOfNights(this.util.formateDate(checkin), this.util.formateDate(checkout)) }, { emitEvent: false });
            }
        });
    }

    getAutoCompleteLocations(event) {
        let inpValue = event.target.value;
        this.locations.length = 0;
        if (inpValue.length > 0 && (event.timeStamp - this.lastKeyupTstamp > 10)) {
            this.isLoading = true;
            const city_name = `${event.target.value}`;
            this.apiHandlerService.apiHandler('cityList', 'POST', '', '', { city_name })
                .pipe(
                    tap(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe((resp: any) => {
                    if (resp.statusCode == 200) {
                        this.locations = resp.data;
                        this.cdr.detectChanges();
                    } else {
                        log.error('Something went wrong')
                    }
                }, err => { log.error(err) });
            this.lastKeyupTstamp = event.timeStamp;
        }
    }

    selectedLocation(location) {
        this.city = location;
        this.regConfig.patchValue({
            cityName: `${location['cityName'] + ' (' + location['countryCode'] + ')'}`,
            cityId: `${location['cityId']}`,
            booking_source: `${location['booking_source']}`
        })
        this.locations = [];
        this.checkinDate.nativeElement.focus();
        this.checkinDate.nativeElement.click();
        return;
    }

    submitForm(data: any) {
        this.hotelService.hotelsCopy.next([]);
        this.hotelService.hotels.next([]);
        this.callResult.emit(data);
    }

    onSubmit(): void {
        this.hotelService.loading.next(true);
        this.globals.toggleSidebar = true;
        this.submitSessionHotelSearchKeyCheck = true;
        this.hotelService.formFilled.next({});
        if (this.city) {
            this.regConfig.value['destination_id'] = this.city;
            this.regConfig.value['destination_source'] = this.booking_source;
        }
        this.hotelService.formFilled.next(this.regConfig.value);
        sessionStorage.removeItem('hotelSearchData');
        sessionStorage.setItem('hotelSearchData', JSON.stringify(this.regConfig.value));
        sessionStorage.setItem('submitSessionHotelSearchKeyCheck', 'true');
        setTimeout(() => {
            this.isOpen = false;
            this.travellersFadeinn = false;
        }, 100);

        if (this.router.url == '/hotel-results') {
            this.hotelService.formFilled.next(this.regConfig.value);
            this.prepareSearchPayloadFromSessionData('hotelSearchData');
            this.router.navigate(["/hotel-results"]);
        }
        this.hotelService.isCollapsed.next(true);
        const formData = {
            // UserId: this.currentUser,
            UserType: "B2C",
            CheckIn: this.regConfig.value.checkin,
            CheckOut: this.regConfig.value.checkout,
            Currency: "BDT",
            Market: "GB",
            CancellationPolicy: true,
            CityIds: this.regConfig.value['cityId'],
            NoOfRooms: this.regConfig.value.rooms,
            RoomGuests: Number(this.regConfig.value.adults) + Number(this.regConfig.value.childs)
        };
        this.submitForm(formData);
        this.hotelService.formFilled.next(this.regConfig.value);
        let reqBody = this.prepareSearchPayloadFromSessionData('hotelSearchData');
        this.hotelService.searchResult(reqBody);
        this.router.navigateByUrl("/hotel-results");
    }

    prepareSearchPayloadFromSessionData(sessionKey: string): any {
        const ssd = JSON.parse(sessionStorage.getItem(sessionKey));
        let RoomGuests = [];
        RoomGuests.push({
            "NoOfAdults": Number(ssd['adults']),
            "NoOfChild": Number(ssd['childs']),
        })

        let reqBody = {
            "CheckIn": `${(moment(ssd['checkin'])).format('YYYY-MM-DD')}`,
            "CheckOut": `${moment(ssd['checkout']).format('YYYY-MM-DD')}`,
            "Currency": 'USD',
            "Market": "BD",
            "CancellationPolicy": true,
            "CityIds": [
                `${ssd['cityId'] || ssd['destination_id']['cityId']}`
            ],
            NoOfRooms: Number(ssd['rooms']),
            RoomGuests,
            booking_source: ssd['destination_source']
        }
        this.hotelService.searchResult(reqBody);
        return reqBody;
    }


    clearDate() {
        this.regConfig.patchValue({ checkinDate: '', checkin: '', checkout: '', nights: '' }, { emitEvent: false });
    }

    onDateChange(date: Date) {
        console.log(date);
    }

    onCheckIn(event) {
        if (event) {
            setTimeout(() => {
                this.checkoutDate.nativeElement.click();
                this.setMinDate = event;
            }, 10)
        }
    }

    onCheckOut(event) {
        if (event) {
            setTimeout(() => {
                this.openRooms = true;
            }, 100)
        }
    }

    ngOnDestroy(): void {
        this.subSunk.unsubscribe();
    }
}